export default __webpack_public_path__ + "static/media/Birthday Cake - Reed Mathis.d106cb82.mp3";